import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { CgCalendarDates } from "react-icons/cg";
import { IoMdTime } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./ChatInfo.css";

const EventChatInfo = ({ control, register, errors }) => {
  const dispatch = useDispatch();

  const excludeWeekends = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  const generateTimeOptions = () => {
    const timeOptions = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const hourString = String(hour).padStart(2, "0");
        const minuteString = String(minute).padStart(2, "0");
        const amPm = hour < 12 ? "AM" : "PM";
        const hour12 = hour === 0 ? 12 : hour <= 12 ? hour : hour - 12;
        timeOptions.push(`${hour12}:${minuteString} ${amPm}`);
      }
    }
    return timeOptions;
  };
  const timeOptions = generateTimeOptions();

  return (
    <div className="container">
      <div className="content-box">
        <div>
          <div className="flex items-center gap-4 w-full">
            <div className="appoint-date">
              <label className="date-label" htmlFor="appointmentDate">
                Appointment date
              </label>
              <div>
                <Controller
                  control={control}
                  name="date"
                  render={({ field }) => (
                    <DatePicker
                      placeholderText="Select date"
                      onChange={(date) => field.onChange(date)}
                      selected={field.value}
                      autoFocus={false}
                      className="date-input"
                      dateFormat="dd-MM-yyyy"
                      minDate={new Date()}
                      filterDate={excludeWeekends}
                    />
                  )}
                />
                <div className="input-date-icon">
                  <CgCalendarDates />
                </div>
              </div>

              <p>
                {errors.date && (
                  <span className="error">{errors.date.message}</span>
                )}
              </p>
            </div>
            <div className="appoint-time">
              <label className="time-label" htmlFor="appointmentTime">
                Time
              </label>

              <select
                {...register("time")}
                name="time"
                className="bg-white time-input"
              >
                <option value="">Select</option>
                {timeOptions.map((timeOption) => (
                  <option key={timeOption} value={timeOption}>
                    {timeOption}
                  </option>
                ))}
              </select>
              <div className="input-time-icon">
                <IoMdTime />
              </div>

              <p>
                {errors.time && (
                  <span className="error">{errors.time.message}</span>
                )}
              </p>
            </div>
            <div className="mode-group">
              <label className="mode-label" htmlFor="preferredMode">
                Preferred Mode
              </label>
              <select
                {...register("mode")}
                name="mode"
                className="select-label"
              >
                <option value="">Select</option>
                <option value="virtualMeeting">Virtual Meeting</option>
                <option value="PhysicalMeeting">In Person</option>
              </select>

              <p>
                {errors.mode && (
                  <span className="error">{errors.mode.message}</span>
                )}
              </p>
            </div>
          </div>
          <div className="horizontal-line"></div>

          {/* Add functionality to other labels and inputs */}
          <div className="supplies">
            <label htmlFor="supplies" className="supply-label">
              Which Supplies are you in charge of procuring?
            </label>
            <select
              {...register("supplies")}
              name="supplies"
              className="select-supply"
            >
              <option value="">Select</option>
              <option value="blood">Blood</option>
              <option value="oxygen">Oxygen</option>
              <option value="medicine">Medical consumables</option>
              <option value="equipment">Equipment</option>
              <option value="procureAll">Procure All</option>
            </select>

            <p>
              {errors.supplies && (
                <span className="error">{errors.supplies.message}</span>
              )}
            </p>
          </div>

          <div className="procure">
            <label htmlFor="procure" className="procure-label">
              How often do you procure?
            </label>
            <select
              {...register("frequency")}
              name="frequency"
              className="procure-supply"
            >
              <option value="">Select</option>
              <option value="monthly">Monthly</option>
              <option value="weekly">Weekly</option>
              <option value="anytime">Just any time</option>
            </select>

            <p>
              {errors.frequency && (
                <span className="error">{errors.frequency.message}</span>
              )}
            </p>
          </div>

          <div className="spend">
            <label htmlFor="spend" className="spend-label">
              How much do you typically spend on all supplies when you order
              supplies?
            </label>
            <div className="relative">
              <select
                {...register("currency")}
                name="currency"
                className="absolute w-10 bg-white outline-none inset-y-0 left-0 pt-1 border border-gray-300 rounded-lg "
              >
                <option value="₦">₦</option>
                <option value="(KES)">KES</option>
                <option value="ETB">ETB</option>
              </select>
              <input
                {...register("amounts")}
                type="number"
                name="amounts"
                className="pl-10 outline-none w-full p-3 border border-gray-300 rounded-lg "
              />

              <p>
                {errors.amounts && (
                  <span className="error">{errors.amounts.message}</span>
                )}
              </p>
            </div>
          </div>

          <div className="important">
            <label htmlFor="important" className="impor-label">
              What value is most important to you?
            </label>
            <select
              {...register("value")}
              name="value"
              className="impor-supply"
            >
              <option value="">Select</option>
              <option value="fast">Fast Deliveries</option>
              <option value="save">Safe Supplies</option>
              <option value="reliable">Reliable Service</option>
              <option value="all">All of the above</option>
            </select>

            <p>
              {errors.value && (
                <span className="error">{errors.value.message}</span>
              )}
            </p>
          </div>

          <div className="chat">
            <label htmlFor="chat" className="chat-label">
              What's the one thing you would change about your current
              suppliers?
            </label>
            <textarea
              {...register("feedback")}
              type="text"
              name="feedback"
              className="chat-input"
            />

            <p>
              {errors.feedback && (
                <span className="error">{errors.feedback.message}</span>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventChatInfo;
